import { createErrorTransformer } from 'store/queries/utils.ts'
import { Flow } from 'types/logging.ts'
import { boltBackend } from '../index.ts'
import { GetAppliedDiscountsResponseBody, ServiceContract } from '@boltenergy-be/shared'
import { BOLT_BACKEND_TAGS } from 'store/queries/bolt-backend/constants.ts'
import { convertBase64toBlob } from 'utils/format.ts'

export const serviceContractsBoltBackend = boltBackend.injectEndpoints({
  endpoints: (builder) => ({
    // GET APPLIED DISCOUNTS
    getAppliedDiscounts: builder.query<GetAppliedDiscountsResponseBody, Partial<Pick<ServiceContract, 'contractNumber'>>>({
      query: ({ contractNumber }) => {
        if (!contractNumber) {
          throw new Error('Contract number is missing.')
        }

        return `/resources/service-contracts/${contractNumber}/discounts`
      },
      transformResponse: ({ data }) => data,
      transformErrorResponse: createErrorTransformer(`[${Flow.DISCOUNTS}:getAppliedDiscounts]`),
      providesTags: [BOLT_BACKEND_TAGS.discounts]
    }),

    // GET SERVICE CONTRACT PDF
    getServiceContractPdf: builder.query<Blob, Partial<Pick<ServiceContract, 'contractNumber'>>>({
      query: ({ contractNumber }) => {
        if (!contractNumber) {
          throw new Error('Contract number is missing.')
        }

        return `/resources/service-contracts/${contractNumber}/pdf`
      },
      transformResponse: ({ data }: { data: { contractPdf: string } }) => convertBase64toBlob(data.contractPdf, 'application/pdf'),
      transformErrorResponse: createErrorTransformer(`[${Flow.CONTRACTS}:getServiceContractPdf]`)
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAppliedDiscountsQuery, useGetServiceContractPdfQuery } = serviceContractsBoltBackend
